/**
 * @generated SignedSource<<a8aa6392d2a105c6b65f7faa2a0e67be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type autoCorrection_AtlassianSearchPage$data = {
  readonly confidenceScore: number | null | undefined;
  readonly originalQuery: string | null | undefined;
  readonly originalQueryType: string | null | undefined;
  readonly replacementQuery: string | null | undefined;
  readonly shouldTriggerAutocorrectionExperience: boolean | null | undefined;
  readonly suggestedQuery: string | null | undefined;
  readonly " $fragmentType": "autoCorrection_AtlassianSearchPage";
};
export type autoCorrection_AtlassianSearchPage$key = {
  readonly " $data"?: autoCorrection_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"autoCorrection_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "autoCorrection_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "originalQuery"
    },
    {
      "kind": "ScalarField",
      "name": "replacementQuery"
    },
    {
      "kind": "ScalarField",
      "name": "suggestedQuery"
    },
    {
      "kind": "ScalarField",
      "name": "originalQueryType"
    },
    {
      "kind": "ScalarField",
      "name": "confidenceScore"
    },
    {
      "kind": "ScalarField",
      "name": "shouldTriggerAutocorrectionExperience"
    }
  ],
  "type": "SearchQueryInfo"
};

(node as any).hash = "c10236f368a121324971f6864af67d34";

export default node;
